import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Alert from "../common/Alert";
import Button from "../common/Button";
import { useGetEdgeStoreSetupQuery } from "../../store/api";
import {
  clearEdgeStoreSetup,
  persistEdgeStoreSetup,
} from "../../utils/edgeStoreSetup";
import { getErrorMessage } from "../../utils/errorMessage";

const SetupGate = ({ children }) => {
  const location = useLocation();
  const { data, isLoading, isError, error, refetch } = useGetEdgeStoreSetupQuery();

  const isConfigured = Boolean(data?.isConfigured);
  const isSetupRoute = location.pathname === "/setup/store";

  useEffect(() => {
    if (isConfigured) {
      persistEdgeStoreSetup(data);
      return;
    }

    if (data?.isConfigured === false) {
      clearEdgeStoreSetup();
    }
  }, [data, isConfigured]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--color-sand)] px-4">
        <div className="w-full max-w-md rounded-xl bg-white p-8 text-center shadow-[0_12px_24px_rgba(15,23,42,0.12)] dark:bg-slate-800 dark:shadow-[0_12px_24px_rgba(0,0,0,0.3)]">
          <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-indigo-600 dark:border-slate-600 dark:border-t-indigo-400" />
          <h1 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
            Loading setup status
          </h1>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
            Checking whether this Edge node is configured.
          </p>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--color-sand)] px-4">
        <div className="w-full max-w-xl space-y-4 rounded-xl bg-white p-8 shadow-[0_12px_24px_rgba(15,23,42,0.12)] dark:bg-slate-800 dark:shadow-[0_12px_24px_rgba(0,0,0,0.3)]">
          <h1 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
            Unable to load setup status
          </h1>
          <Alert tone="error">
            {getErrorMessage(error, "Failed to check Edge store setup.")}
          </Alert>
          <div className="flex gap-3">
            <Button size="sm" onClick={() => refetch()}>
              Retry
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (!isConfigured && !isSetupRoute) {
    return <Navigate to="/setup/store" replace state={{ from: location }} />;
  }

  if (isConfigured && isSetupRoute) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default SetupGate;
